var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 176.292 176.292",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.768,78.685c4.321-16.125,2.103-32.968-6.244-47.426C127.392,11.978,106.633,0,84.347,0 c-10.912,0-21.7,2.899-31.199,8.383c-14.458,8.347-24.8,21.825-29.121,37.951c-4.321,16.125-2.104,32.968,6.244,47.426 c11.132,19.281,31.892,31.259,54.178,31.259c8.41,0,16.745-1.729,24.474-5.03l32.507,56.303l12.99-7.5l-32.508-56.305 C133.087,104.133,141.102,92.37,144.768,78.685z M108.148,103.646c-7.221,4.169-15.417,6.373-23.699,6.373 c-16.944,0-32.727-9.104-41.188-23.759c-6.344-10.988-8.029-23.789-4.745-36.043C41.8,37.96,49.66,27.717,60.648,21.373 C67.87,17.204,76.064,15,84.347,15c16.944,0,32.726,9.104,41.187,23.759c6.344,10.988,8.029,23.789,4.746,36.044 C126.996,87.059,119.136,97.302,108.148,103.646z M59.398,55.009h50v15h-50V55.009z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/zoom-out.3c1b2fcd6646acba94768f9f7da56d37.svg";
export { ForwardRef as ReactComponent };